import axios from "axios";

const API_URL = "https://api.suuplink.suave.ppg.br/api/";

const updateStyle = async ({ styleData, admin, idId }) => {
  return await axios({
    method: "put",
    url: API_URL + `admin/pages/${idId}/style`,
    data: styleData,
    headers: {
      "Content-Type": "application/json",
      "x-access-token": admin.accessToken,
    },
  });
};

const postStyle = async ({ styleData, admin, currentPageId }) => {
  return await axios({
    method: "post",
    url: API_URL + `admin/pages/${currentPageId}/style`,
    data: styleData,
    headers: {
      "Content-Type": "application/json",
      "x-access-token": admin.accessToken,
    },
  })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

const styleService = {
  postStyle,
  updateStyle,
};

export default styleService;
